import saveFrequentlyUsedFolders from '../services/saveFrequentlyUsedFolders';
import { getStore } from '../store/store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { trace } from 'owa-trace';
import { action } from 'satcheljs/lib/legacy';
// Initialize store with frequently used folder list from user configuration
export default action('initializeFrequentlyUsedFolders')(function initializeFrequentlyUsedFolders() {
    var userOptions = getUserConfiguration().UserOptions;
    var isCorrupted = false;
    var store = getStore();
    if (store.isInitialized) {
        return;
    }
    if (userOptions.FrequentlyUsedFolders) {
        userOptions.FrequentlyUsedFolders.forEach(function (folder) {
            try {
                var parsedFolder = JSON.parse(folder);
                store.frequentlyUsedFolders.push(parsedFolder);
            }
            catch (ex) {
                trace.warn('Unable to parse frequently used folders');
                isCorrupted = true;
            }
        });
    }
    store.isInitialized = true;
    // save back the list which excludes corrupted folders
    if (isCorrupted) {
        saveFrequentlyUsedFolders();
    }
});
//# sourceMappingURL=initializeFrequentlyUsedFolders.js.map